"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PatchAutoflowRequest () {
        return PatchAutoflowRequest;
    },
    get PostAutoflowPreviewRequest () {
        return PostAutoflowPreviewRequest;
    },
    get PostAutoflowRequest () {
        return PostAutoflowRequest;
    }
});
const _autoflow = require("./autoflow");
const PostAutoflowRequest = _autoflow.AutoflowModel.omit({
    _id: true
});
const PatchAutoflowRequest = _autoflow.AutoflowModel.partial();
const PostAutoflowPreviewRequest = _autoflow.AutoflowModel.pick({
    tasks: true
});
